import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

type Props = SvgIconProps;

const HeightIcon: React.FC<Props> = (props) => {
  return (
    <SvgIcon width="6" height="16" viewBox="0 0 6 16" {...props}>
      <path
        d="M3.83018 3.8249H5.32185C5.69685 3.8249 5.88018 3.3749 5.61352 3.11657L3.28852 0.799902C3.12185 0.641569 2.86352 0.641569 2.69685 0.799902L0.380185 3.11657C0.113518 3.3749 0.296852 3.8249 0.671852 3.8249H2.16352V12.1749H0.671852C0.296852 12.1749 0.113518 12.6249 0.380185 12.8832L2.70518 15.1999C2.87185 15.3582 3.13018 15.3582 3.29685 15.1999L5.62185 12.8832C5.88852 12.6249 5.69685 12.1749 5.33018 12.1749H3.83018V3.8249Z"
        fill="#B8BEC9"
      />
    </SvgIcon>
  );
};

export default HeightIcon;
